/* The password stays in Shopify's native form; this only changes its visibility. */
(() => {
  const button = document.querySelector('.bw-password-toggle');
  const input = document.getElementById('CustomerPassword');
  button?.addEventListener('click', () => {
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
  });
})();
